import { AlignmentType, ImageRun, Paragraph, TextRun, WidthType } from "docx";
import methodology from '../../../../../../Assests/ReportImages/approachMethodology.png'
const setupMethodology = await fetch(methodology).then(response => response.blob())
export function auditMethodologyText(customerName, applicationName) {
    return new Paragraph({
        alignment: AlignmentType.JUSTIFIED,
        spacing: { before: 200, after: 300 },

        children: [
            new TextRun({
                text: "Audit Methodologies like OWASP Code Review, CERT Secure Coding Standards, CWE/SANS Top 25, frameworks to execute the " + applicationName + " Source Code belonging to " + customerName,
                size: 24,
                color: "000000",
                font: "Arial",
                bold: false,
                italics: false
            })
        ],
    })
}
const approachMethodology = new ImageRun({
    type: 'png',
    data: await setupMethodology.arrayBuffer(),
    transformation: {
        width: 600,
        height: 350
    },
});


export const setUpAndMethodology = new Paragraph({
    indent: { left: 130 },
    spacing: { before: 350 },
    alignment: AlignmentType.CENTER,
    children: [approachMethodology]
})


export const InformationGathering = new Paragraph({
    alignment: AlignmentType.LEFT,
    spacing: { before: 500, after: 200 },
    children: [
        new TextRun({
            text: "Information Gathering",
            size: 24,
            color: "2F5496",
            font: "Arial",
            bold: true,
            italics: false
        })
    ],
})

export const InformationGatheringText = new Paragraph({
    alignment: AlignmentType.JUSTIFIED,
    // spacing: { before: 100, after: 200 },
    spacing: { line: 376 },
    children: [
        new TextRun({
            text: "The objective of this phase is to get better understanding of the applications which helps in identifying business risks and possible threats to the application. It is carried out through discussion with the application owners to know more about application, its features, functionalities, critical transactions, sensitive information and its end users etc. ",
            size: 24,
            color: "000000",
            font: "Arial",
            bold: false,
            italics: false
        })
    ],
})

export const informationBullet1 = new Paragraph({
    indent: { left: 800, },
    spacing: { line: 276, before: 150, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Understating the application & its features",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const informationBullet2 = new Paragraph({
    indent: { left: 800, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Identify Security Code Review Objectives",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const informationBullet3 = new Paragraph({
    indent: { left: 800, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Understanding the business criticality to the organization",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const informationBullet4 = new Paragraph({
    indent: { left: 800, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Identifying critical and sensitive information it is handling",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})


export const informationBullet5 = new Paragraph({
    indent: { left: 800, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Identifying its end users",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})



